// extracted by mini-css-extract-plugin
module.exports = {"buttonFilter":"game-options_buttonFilter__NDAHw","wiggle":"game-options_wiggle__BtksK"};